<template>
  <div>
    <header-slot>
      <template v-slot:content-right>
        <div class="mr-3">
          <b-button
            v-if="currentTab == 'role'"
            @click="$refs['routerViewTab'].newRole()"
            v-t="'CREATE'"
            variant="outline-success"
          ></b-button>
          <b-button
            v-if="currentTab == 'area'"
            @click="$refs['routerViewTab'].newArea()"
            v-t="'CREATE'"
            variant="outline-success"
          ></b-button>
        </div>
      </template>
    </header-slot>
    <b-nav card-header pills class="m-0">
      <b-nav-item
        v-for="(item, index) in tabs"
        :key="index"
        :to="{ name: item.name }"
        exact
        exact-active-class="active"
        :link-classes="['px-3', bgTabsNavs]"
        >{{ $t(item.title) | capitalize }}
      </b-nav-item>
    </b-nav>
    <b-card
      no-body
      class="border-top-primary border-3 border-table-radius px-0"
    >
      <router-view ref="routerViewTab" :key="routeName" />
    </b-card>
  </div>
</template>


<script>
/* SERVICES */
import { mapGetters } from "vuex";
import Ripple from "vue-ripple-directive";

export default {
  components: {},
  directives: {
    Ripple,
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    tabs() {
      return this.$route.matched[1].meta.tabs;
    },
    currentTab() {
      return this.$route.meta.tab;
    },
    routeName() {
      return this.$route.name;
    },
  },
  methods: {},
};
</script>
    
    
    